<template>
    <div>
        <!-- 上传图片弹窗 -->
        <el-dialog
            title="上传图片"
            :visible.sync="uploadDialogVisible"
            width="1000px"
            :close-on-click-modal="false"
            @closed="handleDialogClose"
        >
            <!-- 初始上传区域（无图片时） -->
            <div v-if="!previewImage" style="width:950px;background: #F0F1F4;">
                <el-upload
                    class="custom-upload"
                    action=""
                    :auto-upload="false"
                    :multiple="false"
                    :show-file-list="false"
                    :on-change="handleFileChange"
                    :before-upload="beforeUpload"
                    drag
                >
                    <div class="upload-content">
                        <el-button icon="el-icon-upload2" >点击上传</el-button>
                        <span class="upload-tip-text">或将图片拖拽到此区域</span>
                        <div class="upload-desc">
                            长、宽大于等于100px，小于等于4096px；图片大小不超过4M；<br>
                            支持上传jpg, png, jpeg, gif, bmp格式
                        </div>
                    </div>
                </el-upload>

            </div>

            <!-- 预览区域（已选择图片时） -->
            <div v-else class="preview-container">
                <div class="preview-box">
                    <img :src="previewImage" alt="预览图片" class="preview-img" />
                </div>

            </div>

            <!-- 底部按钮 -->
            <span slot="footer" class="dialog-footer">
                <el-button type="text" @click="resetUpload" v-if="previewImage" style="position: absolute;left: 16px;bottom:16px" :disabled="loading">重新上传</el-button>
                <el-button @click="uploadDialogVisible = false">取消</el-button>
                <el-button
                    v-if="previewImage"
                    :loading="loading"
                    type="primary"
                    @click="handleStartUpload"
                >
                  开始上传
                </el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
    import {uploadImageFiles} from '@/api/xunyou';

    export default {
        name: 'ImageUploadDialog',
        data() {
            return {
                loading:false,
                uploadDialogVisible: true,
                previewImage: '', // 预览图片地址
                selectedFile: null, // 选中的文件对象
            };
        },
        methods: {
            // 上传前校验
            beforeUpload(file) {
                const isAllowedType = ['image/jpeg', 'image/png', 'image/gif', 'image/bmp'].includes(file.type);
                const isLt4M = file.size / 1024 / 1024 < 4;

                if (!isAllowedType) {
                    this.$message.error('上传图片格式不正确，请上传jpg、png、jpeg、gif、bmp格式的图片！');
                    return false;
                }
                if (!isLt4M) {
                    this.$message.error('上传图片大小不能超过 4MB!');
                    return false;
                }

                // 校验图片分辨率
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const img = new Image();
                        img.src = e.target.result;
                        img.onload = () => {
                            const { width, height } = img;
                            if (width < 100 || height < 100 || width > 4096 || height > 4096) {
                                this.$message.error('图片分辨率需在100px~4096px之间！');
                                resolve(false);
                            } else {
                                resolve(true);
                            }
                        };
                    };
                    reader.readAsDataURL(file);
                });
            },

            // 文件选择/拖拽后触发
            handleFileChange(file) {
                // 生成预览图
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.previewImage = e.target.result;
                };
                reader.readAsDataURL(file.raw || file);
                this.selectedFile = file.raw || file;
            },

            // 重置上传（重新上传）
            resetUpload() {
                this.previewImage = '';
                this.selectedFile = null;
            },

            // 点击开始上传按钮
            handleStartUpload() {
                if (!this.selectedFile) {
                    this.$message.warning('请先选择图片！');
                    return;
                }
                // 这里写你的上传逻辑，例如：
                // const formData = new FormData();
                // formData.append('file', this.selectedFile);
                // axios.post('/api/upload', formData).then(res => { ... })

                this.$message.success('开始上传图片！');
                // 上传完成后可关闭弹窗
                // this.uploadDialogVisible = false;
                //

                this.loading = true
                const formData = new FormData()
                console.log(this.selectedFile)

                formData.append('file', this.selectedFile)
                formData.append('bizType', 'goods_image_search')
                formData.append('source', 'pc')
                uploadImageFiles(formData).then(res=>{
                    if(res.success){
                        this.$message({
                            type: 'success',
                            message: '上传搜索图成功'
                        })
                        this.selectedFile = ''
                        this.$emit('closeDialog',res.data.imageUrl,res.data.uploadLogId)
                    }else{
                        this.$message.error("上传失败，请稍后再试！");
                    }
                }).finally(()=>{
                    this.loading = false
                })
            },

            // 弹窗关闭时重置状态
            handleDialogClose() {
                this.resetUpload();
            }
        }
    };
</script>

<style scoped lang="less">
    /* 弹窗整体 */
    .upload-container {
        background-color: #f5f7fa;
        border-radius: 4px;
        padding: 40px 20px;
    }
    .custom-upload {
        width: 100%;
        //height: 240px;
        border: none;
    }
    .upload-content {
        text-align: center;
        /deep/ .el-button{
            border-color:#237AE4 !important;
            border-radius: 22px !important;
            color:#237AE4 !important;
        }
    }
    /deep/ .el-upload-dragger{
        width: 100%;
        height: 240px;
        padding-top: 70px;
        background:#F0F1F4;
        border: 0;
        box-sizing: border-box;
    }
    /deep/ .el-icon-upload2{
        margin: 0;
    }
    .upload-btn-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
    }
    .upload-tip-text {
        font-size: 16px;
        color: #303133;
    }
    .upload-desc {
        margin-top: 5px;
        font-size: 14px;
        color: #909399;
        line-height: 1.6;
    }

    /* 预览区域样式 */
    .preview-container {
        text-align: center;
        //height: 500px;
        padding: 20px 0;
        background: url("../assets/img/preview_bg.png") no-repeat center center;
        background-size: 100% auto;
    }
    .preview-box {
        display: inline-block;
        background: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAADklEQVQImWNgYGD4z8AABQABXv2qFAAAAAElFTkSuQmCC') repeat;
        border: 1px solid #409eff;
        padding: 10px;
    }
    .preview-img {
        max-width: 400px;
        max-height: 300px;
        display: block;
    }
    .preview-actions {
        margin-top: 15px;
        text-align: left;
    }

    /* 底部按钮 */
    .dialog-footer {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/searchImgUploadDialog.vue